// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2M2v_","title":"Images90_title__3kjb5","images":"Images90_images__xFq2B"};